import { isCompliancePath } from '@/features/compliance/lib/constants'

// Routes that suppress the Adviser widget. Patterns are matched against
// `pathname + search`. Path-anchored rules end in `(?:\?|$)` so a trailing
// query string (e.g. `/banking?utm=x`) still matches — anchoring on `$` alone
// would let any stray query param defeat suppression. Query-dependent rules
// (the onboarding stage) match against the search string directly.
const ADVISER_HIDDEN_ROUTE_PATTERNS: RegExp[] = [
  /^\/banking(?:\?|$)/,
  /^\/banking\/apply(?:\?|$)/,
  // Matches ?stage=banking and ?x=1&stage=banking&y=2; rejects ?stage=banking-intro
  /^\/onboarding-v2\?(?:.*&)?stage=banking(?:&|$)/,
  /^\/admin(?:\/|\?|$)/,
]

export const isAdviserHiddenRoute = (path: string): boolean => {
  const [pathname = ''] = path.split('?')

  return (
    isCompliancePath(pathname) ||
    ADVISER_HIDDEN_ROUTE_PATTERNS.some((pattern) => pattern.test(path))
  )
}
